<template>
  <div>
    <div v-if="row.current_stage && row.current_stage.current_negotiation">
      <div v-if="row.current_stage.current_negotiation.description && row.current_stage.current_negotiation.description.length > 0">
        {{ row.current_stage.current_negotiation.description }}
      </div>
      <div v-else>
        {{ $companyConfiguration.cardStageNegotiations.getNegotiationNameByType(row.current_stage.current_negotiation.type) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "current-stage-column-template",
  components: {},
  props: {
    row: {type: Object, required: true}
  },
  data() {
    return {}
  },
  mounted() {
  },
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style>
  .table-router-link {
    text-decoration: none;
  }
</style>